import firebase from "store/firebase";
import "firebase/auth";
import "firebase/firestore";
import { AnyAction, Dispatch } from "redux";
import { RootState } from "store/reducer";
import { ANSWERS_ACTION_TYPES, TastingAnswer } from "./reducer";
import { answerFromDoc, answerToDocData } from "./utils";
import { invalidateResourceRead } from "store/util/resource-read";
import { StoreError } from "store/errors";

export const ACTION_EVENT_ANSWERS_UPDATING = 'event_answers/updating';
export const ACTION_EVENT_ANSWERS_UPDATED = 'event_answers/updated';
export const ACTION_EVENT_ANSWERS_UPDATE_ERROR = 'event_answers/update_error';

export default function update(eventId: string, answer: TastingAnswer) {
    return async (dispatch: Dispatch<AnyAction>, getState: () => RootState) => {
        const { auth } = getState();
        const id = auth?.user?.email;
        dispatch({ type: ACTION_EVENT_ANSWERS_UPDATING, payload: true});
        try {
            const eventDocRef = firebase
              .firestore()
              .collection("events")
              .doc(eventId);
            const event = (await eventDocRef.get({ source: "server" })).data();
            const managesEvent = id && (id === event?.owner || id === event?.bartender);
            if (event?.editingAllowed !== true && !managesEvent) {
                throw new StoreError("Editing is closed for this event. Your answers were not saved.", 403);
            }
            const itemRef = eventDocRef.collection("answers").doc(id);
            const docData = answerToDocData(answer);
            await itemRef.update(docData);
            
            const doc = await itemRef.get();
            answer = answerFromDoc(doc, eventId);

            invalidateResourceRead(getState, [ANSWERS_ACTION_TYPES.startedLoading, eventId, id]);
            dispatch({ type: ACTION_EVENT_ANSWERS_UPDATED, payload: answer});
        }
        catch (error) {
            const saveError = (error as { code?: string })?.code === "permission-denied"
              ? new StoreError("Unable to save your answers. Editing may have closed. Refresh the event and try again.", 403)
              : error;
            dispatch({ type: ACTION_EVENT_ANSWERS_UPDATE_ERROR, payload: saveError});
        }
        dispatch({ type: ACTION_EVENT_ANSWERS_UPDATING, payload: false});
    }
}
